if (!customElements.get('fills-navigation')) {
  customElements.define('fills-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const drawer = this.closest('header-drawer');
        if (!drawer) return;
        const url = new URL(link.href, window.location.href);
        const summary = drawer.querySelector('summary');
        if (typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event, summary);
        summary?.setAttribute('aria-expanded', 'false');
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname || !url.hash) return;
        const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
        if (!target) return;
        event.preventDefault();
        history.pushState(null, '', url.hash);
        requestAnimationFrame(() => {
          target.scrollIntoView({ block: 'start', behavior: 'auto' });
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        });
      });
    }
  });
}
